// extracted by mini-css-extract-plugin
export default {"pageTitle":"text_pageTitle__h9tEI","sectionTitle":"text_sectionTitle__moUhs"};